/* File defines run() - the top level interpreter rending code */
import { Globals, LoadingScreen } from "./main"
import { PNCxLuaReader } from "./PNCxLuaReader";
import { IntegerDictionary, Dictionary, PNCTypes, isCutsceneType } from "./TypesAndEnums";
import * as DBTypes from "./database"
import * as Helpers from "./helpers"
import * as Renderer from "./renderCutscene"
//declare var __JS_SCRIPTS_PATH: string;

let fgEffects = <HTMLTemplateElement>document.getElementById("fgEffects");

export async function run(episode:PNCTypes.Episode, jumpTo:HTMLElement = null)
{
	changeTabName(episode);
	// const hashNoPart = '#'+episode.permalink;
	// if (episode.permalink && window.location.hash != hashNoPart)
	// 	window.location.hash = hashNoPart;

	//const loading = getLoadingFunctions();
	//loading.startLoading(episode.name, episode.desc);
	(document.getElementById("chapterName") as HTMLHeadingElement).innerText = episode.name;
	(document.getElementById("chapterDesc") as HTMLHeadingElement).innerText = episode.description || "";

	/* Construct all parts in one big div, done in a fragment to avoid slowing the DOM. */
	let docFragment = document.createDocumentFragment();
	
	// Don't keep audio running
	(document.getElementById('audioPlayer') as HTMLAudioElement)?.pause();


	const loadingScreen = new LoadingScreen(episode.parts.length);

	//TODO: Considering none of this causes global side effects can't we just Promise.All it?
	let partCounter = 1; /* The refactor to tips and events causes too much "part" text bloat, this is a workaround. */
	for(var p = 0; p < episode.parts.length; p++)
	{

		//TODO: This doesn't work correctly right now, it should clump together if isCutsceneType()==false
		let thisPartDiv = document.createElement('div');
		thisPartDiv.id = 'part'+p;
		// Scrollspy will observe elements with this class name. 
		// Then it will call this.getActiveElement(id) to get the element to add/remove the .active class.
		// In this case it will add/remove .active to the table of contents on the right
		thisPartDiv.classList.add("scrollspy");

		if (episode.parts.length > 1) {
			//TODO: part_names is not implemented yet

			//This is only incremented and rendered when it's a story scene or the previous part was a story scene
			//Or if there was no previous part, always render it
			if(isCutsceneType(episode.parts[p].type) || (p != 0 && isCutsceneType(episode.parts[p - 1].type)) || p==0) {
				let h3 = document.createElement('h3');
				h3.innerText = `Part ${partCounter}`;
				docFragment.appendChild(h3);
				++partCounter;
			}
		}

		if (isCutsceneType(episode.parts[p].type)) {

			await doCutsceneRendering(thisPartDiv, episode.parts[p].script, p).catch(error => {
				const p1 = document.createElement("p");
				const p2 = document.createElement("p");
				p1.classList.add("error-text")
				p2.classList.add("error-text")
				p1.innerText = "The interpeter encountered an error on "+episode.parts[p].script+". Most likely this file is missing."
				p2.innerText = error;
				docFragment.appendChild(p1);
				docFragment.appendChild(p2);
			}); 
			doToolTips(thisPartDiv);

		} else {

			//TODO: Remove this and switch back to regular if/else or find some better way to write it
			//We shouldn't have functions that cause side effects. they should be return oriented.
			//Unfortunately with the way it's currently written some elements need to append more than one object (ex. Title and content)

			/* Function lookup table. This should be a bit faster than a switch statement. */
			const renderFunctions = {
				[DBTypes.StoryType.BATTLE_EVENT]: doExploreEventRendering,
				[DBTypes.StoryType.EXPLORATION_TIP]: doExplorationTipRendering,
				[DBTypes.StoryType.PROFESSOR_TIP]: doProfessorTipRendering,
				[DBTypes.StoryType.PROTOCOL_CARD]: doProtocolCardRendering,
				[DBTypes.StoryType.INGAME_MAIL]: doIngameMailRendering,
			};
			/* Is this part faster though? Probably. Fewer JE instructions. */
			const renderFunc:Function = renderFunctions[episode.parts[p].type];
			fgEffects = <HTMLTemplateElement>document.getElementById("fgEffects");
			if (renderFunc) {
				renderFunc(thisPartDiv, episode.parts[p]); 
			} else {
				//throw new Error("Invalid database entry: "+ JSON.stringify(episode.parts[p]))
				
				const p1 = document.createElement("p");
				//const p2 = document.createElement("p");
				p1.classList.add("error-text")
				//p2.classList.add("error-text")
				p1.innerText = "Invalid database entry, cannot render this part: "+JSON.stringify(episode.parts[p]);
				thisPartDiv.appendChild(p1);
				//docFragment.appendChild(p2);
			}
		}

		docFragment.appendChild(thisPartDiv);

		//debugger;
		loadingScreen.setProgress(p+1);
	}

	let newSimpleTextDiv = document.createElement('div');
	newSimpleTextDiv.appendChild(docFragment);
	const oldSimpleTextDiv = document.getElementById("verySimpleText");
	newSimpleTextDiv.id = "verySimpleText"; /* If we could style the fragment directly this wouldn't be necessary... */
	oldSimpleTextDiv.parentNode.replaceChild(newSimpleTextDiv, oldSimpleTextDiv);
	
	if(jumpTo)
		jumpTo.scrollIntoView({behavior: 'smooth'});

	if (episode.permalink) {
		Helpers.setCookie('lastViewedScene', episode.permalink, 180);
		Globals.CurrentEpisode = episode.permalink;
	}
}

/* run() child functions for cleanliness */

//Used to determine what file type to load. The language code follows the game internal name!
const LANGUAGE_AVG = {
	"en/":"EN_US.json", // com.sunborn.neuralcloud.en
	"cn/":"ZH_CN.lua",
	"jp/":"JA_JP.luac", //com.sunborn.neuralcloud.jp
	//"kr/":"EN_US.json",
	//"ru/":"EN_US.json",
	//"za/":"US"
};

/**
 * Does cutscene rendering. 
 * YOU MUST CATCH EXCEPTIONS THROWN BY THIS FUNCTION!!!!
 * This function will NOT cause side effects!!! It is up to other functions to handle it!
 * @param {any} NewSimpleTextDiv - Div to render to
 * @param {string} script - Name of script file to load
 * @param {number} partNum
 * @returns {void}
 */
async function doCutsceneRendering(NewSimpleTextDiv:DocumentFragment|HTMLDivElement, script:string, partNum:number) {
	let CURRENT_LANGUAGE = Globals.CurrentLanguage;
	if (!LANGUAGE_AVG[CURRENT_LANGUAGE])
		CURRENT_LANGUAGE = "en/"

	let fileName = ""
	let langFileName = ""
	if (script.indexOf(".") != -1) {
		//script: 23sg.23sg_bs01_2
		//Expand to 
		//fileName = AvgConfig.23sg.23sg_bs01_2.AvgCfg_23sg_bs01_2.json
		//langFileName = AvgConfig.23sg.23sg_bs01_2.AvgLang_23sg_bs01_2_EN_US.json
		let [folder, shortFileName] = script.split(".", 2)
		fileName = `avgtxt/AvgConfig.${script}.AvgCfg_${shortFileName}.json`
		langFileName = `avgtxt/${CURRENT_LANGUAGE}AvgConfig.${script}.AvgLang_${shortFileName}_${LANGUAGE_AVG[CURRENT_LANGUAGE]}`;
	} else if (script.indexOf("/") != -1) {
		fileName = `avgtxt/${script}_AvgCfg.json`
		langFileName = `avgtxt/${script}_AvgLang.json`
	} else {
		// 23carnival_00 expands to:
		// AvgConfig.23carnival_00.AvgCfg_23carnival_00
		// AvgConfig.23carnival_00.AvgLang_23carnival_00_EN_US
		fileName = `avgtxt/AvgConfig.${script}.AvgCfg_${script}.json`;
		langFileName = `avgtxt/${CURRENT_LANGUAGE}AvgConfig.${script}.AvgLang_${script}_${LANGUAGE_AVG[CURRENT_LANGUAGE]}`;
	}
	
	console.log(`fetching ${fileName}`);
	const cfgData:IntegerDictionary<object> = await fetch(fileName).then(r => r.json());
	console.log(`fetching ${langFileName}`)
	const textMap:IntegerDictionary<string> = await fetch(langFileName).then(
		async r => {
			if (langFileName.endsWith(".json"))
				return r.json()
			else
			{
				const out2 = await r.bytes();
				return new PNCxLuaReader(out2).readFile();
			}
		}
	);

	if (Globals.TRUSTY_PATCHES.hasOwnProperty(script)) {
		console.log("Patch found for ",script)
		const patch = Globals.TRUSTY_PATCHES[script];
		
		Object.keys(patch).forEach(frameNum => {
			const frameContent = patch[frameNum];

			for (const [k, value] of Object.entries(frameContent)) {
				if (cfgData.hasOwnProperty(frameNum)) {
					cfgData[frameNum][k] = value
					//console.log("[",frameNum,"][",k,"] = ",value)
				} else {
					console.error("Patch specifies a frame ",frameNum,"that's not in the file!");
				}
			};
		});
	}

	if (Globals.SETTINGS.showDebugOpcodeButton) {
		const debugButton = document.createElement('a');
		debugButton.setAttribute("class", "waves-effect waves-light btn");
		debugButton.setAttribute("href", fileName);
		debugButton.innerText="AvgConfig file for this section (For debugging)";
		NewSimpleTextDiv.appendChild(debugButton);

		const debugButton2 = <HTMLAnchorElement>debugButton.cloneNode()
		debugButton2.href = langFileName;
		debugButton2.innerText="AvgLang file for this section (For debugging)"
		NewSimpleTextDiv.appendChild(document.createTextNode("\u00A0")); //Add a non breaking space
		NewSimpleTextDiv.appendChild(debugButton2);

		NewSimpleTextDiv.appendChild(document.createElement('br'));
	}
	NewSimpleTextDiv.appendChild(await Renderer.renderPNCStructToDiv(cfgData, textMap, partNum));
}


function doExploreEventRendering(NewSimpleTextDiv:DocumentFragment, part:DBTypes.PartData) {
	const card = <HTMLDivElement>fgEffects.content.querySelector(".card.choices.indented").cloneNode(true);

	const descriptionNode = card.querySelector("p");
	descriptionNode.innerHTML = Helpers.parsePNCTextModifiers(part.content);

	const choicesDivNode = card.querySelector(".card-action");
	for (let i = 0, choice; choice = part.choices[i]; i++) {

		const newLink = document.createElement("a");
		newLink.innerHTML = Helpers.parsePNCTextModifiers(choice);
		if (i==part.correctChoice) {
			newLink.classList.add("correct-choice");
		}
		choicesDivNode.appendChild(newLink);

	}

	NewSimpleTextDiv.appendChild(card);
}

function doExplorationTipRendering(NewSimpleTextDiv:DocumentFragment, part:DBTypes.PartData) {
	const msgBox = <HTMLDivElement>fgEffects.content.querySelector(".msgbox").cloneNode(true);
	const [speakerNode, textNode] = <NodeListOf<HTMLDivElement>>msgBox.querySelectorAll(".storyText");
	const nImgNode = msgBox.querySelector("img");

	speakerNode.innerText = part.speaker;
	textNode.innerHTML = Helpers.parsePNCTextModifiers(part.content);
	nImgNode.src = `avgcharacter/face/${part.sprite}.png`;
	NewSimpleTextDiv.appendChild(msgBox);
}

function doProfessorTipRendering(NewSimpleTextDiv:DocumentFragment, part:DBTypes.PartData) {
	const msgBox = <HTMLDivElement>fgEffects.content.querySelector(".msgbox").cloneNode(true);
	const [speakerNode, textNode] = <NodeListOf<HTMLDivElement>>msgBox.querySelectorAll(".storyText");
	const imgNode = msgBox.querySelector("img");
	imgNode.src = `avgcharacter/face/prof_${Globals.SETTINGS.playerGender}_avg_face_15.png`;
	speakerNode.innerText = Globals.SETTINGS.playerName || Globals.DefaultPlayerName;
	textNode.innerHTML = part.content;
	NewSimpleTextDiv.appendChild(msgBox);
}

function doProtocolCardRendering(NewSimpleTextDiv:DocumentFragment, part:DBTypes.PartData) {
	let title = document.createElement("p");
	title.innerText="Obtained Protocol";
	title.classList.add("storyText", "centered");
	NewSimpleTextDiv.appendChild(title);

	const card = <HTMLDivElement>fgEffects.content.querySelector(".card").cloneNode(true);
	const titleNode = <HTMLSpanElement>card.querySelector(".card-title");
	const descNode = <HTMLParagraphElement>card.querySelector("p");

	titleNode.innerText = part.speaker;
	descNode.innerHTML = Helpers.parsePNCTextModifiers(part.content);

	NewSimpleTextDiv.appendChild(card);
}

function doIngameMailRendering(NewSimpleTextDiv:DocumentFragment, part:DBTypes.PartData) {
	const mailCard = <HTMLDivElement>fgEffects.content.querySelector(".card.image").cloneNode(true);
	const mailDesc = <HTMLParagraphElement>mailCard.querySelector("p");
	const mailImg = <HTMLImageElement>mailCard.querySelector(".card-image > img");
	const imgTitle = <HTMLSpanElement>mailCard.querySelector(".card-image > .card-title");

	mailImg.src = `avgcharacter/lpic_${part.sprite}.png`;
	imgTitle.innerText = `From: ${part.speaker}`;
	mailDesc.innerHTML = Helpers.parsePNCTextModifiers(part.content);
	
	NewSimpleTextDiv.appendChild(mailCard);
}
//
/* run() mini helper functions */
//
function changeTabName(episode:PNCTypes.Episode) {
	let part = " — ";
	let parent = episode.chapterName || "";
	window.document.title = `${parent}${part}${episode.name} | Neural Cloud S.I.`;
}

export function doToolTips(NewSimpleTextDiv) {
	NewSimpleTextDiv.querySelectorAll(".tooltip").forEach(el => {
		const definition = Helpers.parsePNCTextModifiers(Globals.DICTIONARY[el.getAttribute('data-id')].des);

		//@ts-ignore
		tippy(el, {
			placement: 'top',
			arrow: true,
			content: definition,
			allowHTML: true,
			interactive: true,
			maxWidth: 400,
		});
	});
}